import { VisitedUrlEventTrigger } from '@mm/state/model/SignalModel';
import { Dispatch } from 'redux';
import SignalVisitedUrlEventTriggersController, {
  CreateEventTrigger,
  UpdateEventTrigger,
} from '../controllers/SignalVisitedUrlEventTriggersController';
import commonHandler from '../errorHandlers/common-handler';
import { integrationsHandler } from '../errorHandlers/integrations-handler';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class SignalVisitedUrlEventTriggersCRUDActions extends CrudActionContainer {
  resetStore: string;
  constructor() {
    super('VISITED_URL_EVENT_TRIGGERS');
    this.resetStore = this.makeActionKey('RESET_STORE');
  }

  create(configurationId: number, visitedUrlEventTrigger: CreateEventTrigger) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));

      try {
        const response: VisitedUrlEventTrigger =
          await SignalVisitedUrlEventTriggersController.create(
            configurationId,
            visitedUrlEventTrigger,
          );
        dispatch(this.retrieved(response));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(
          error,
          integrationsHandler(dispatch, this),
        );
      }
    };
  }

  retrieveById(configurationId: number, id: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAction));

      try {
        const response = await SignalVisitedUrlEventTriggersController.getById(
          configurationId,
          id,
        );
        dispatch(this.retrieved(response));

        return response;
      } catch (error) {
        commonHandler(dispatch)(error);
      }
    };
  }

  retrieveAll(configurationId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      try {
        const response = await SignalVisitedUrlEventTriggersController.getAll(
          configurationId,
        );
        dispatch(this.retrievedAll(response));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }

  remove(configurationId: number, id: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.deleteAction));

      try {
        const response = await SignalVisitedUrlEventTriggersController.remove(
          configurationId,
          id,
        );
        await dispatch(this.deleteLocal({ id }));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }

  update(configurationId: number, visitedUrlEventTrigger: UpdateEventTrigger) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));

      try {
        const response = await SignalVisitedUrlEventTriggersController.update(
          configurationId,
          visitedUrlEventTrigger,
        );
        dispatch(this.retrieved(response));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }
  invalidateStore() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch({ type: this.resetStore });
    };
  }
}

const signalVisitedUrlEventTriggersCRUDActions =
  new SignalVisitedUrlEventTriggersCRUDActions();

export default signalVisitedUrlEventTriggersCRUDActions;

export const useSignalVisitedUrlEventTriggersCRUDActions = getActionHookBuilder(
  signalVisitedUrlEventTriggersCRUDActions,
  [
    'retrieveAll',
    'retrieveById',
    'create',
    'update',
    'remove',
    'invalidateStore',
  ],
);
